import { p as jsxRuntimeExports } from "./doenetml-NmXDuMHr.js";
import React__default from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-iiMuPv8N.js";
const rsq = React__default.memo(function Rsq(props) {
  let { SVs } = useDoenetRenderer(props, false);
  if (SVs.hidden) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: "’" });
});
export {
  rsq as default
};
